export const hasTherapists = (response) => {
  const staffs = response?.data?.data?.list?.staffs ?? response?.data?.list?.staffs;
  return Array.isArray(staffs) && staffs.length > 0;
};

// Day/slot availability is intentionally not pre-checked here; the response
// only reports slot_available per day, and the time page shows its own empty
// state when a day has no slots.
export const checkBookingAvailability = async ({ services, loadStaff }) => {
  const uniqueServices = [...new Map(services.map((service) =>
    [`${service.id}:${service.duration}`, service])).values()];
  const staff = await Promise.all(uniqueServices.map(loadStaff));
  if (!staff.length || staff.some((response) => !hasTherapists(response))) return 'therapists';
  return null;
};
